import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const getHeaders = () => {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    const headers = {};
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    return headers;
};

export async function createAnnouncement(formData) {
    try {
        const response = await axios.post(`${API_BASE}/api/announcements`, formData, {
            headers: {
                ...getHeaders(),
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to create announcement');
    }
}

export async function getAnnouncements() {
    try {
        const response = await axios.get(`${API_BASE}/api/announcements`, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to fetch announcements');
    }
}

export async function toggleAnnouncement(id, isActive) {
    try {
        const response = await axios.patch(`${API_BASE}/api/announcements/${id}/toggle`, { isActive }, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to toggle announcement');
    }
}

export async function deleteAnnouncement(id) {
    try {
        const response = await axios.delete(`${API_BASE}/api/announcements/${id}`, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to delete announcement');
    }
}

export async function getActiveAnnouncement(type) {
    try {
        const response = await axios.get(`${API_BASE}/api/announcements/active?type=${type}`, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to fetch active announcement');
    }
}
